module.exports = __webpack_public_path__ + "media/images/vouchers/spa_duo-db7bd0321fc132a3b80cb436f6cb8166.png";